export * from './autofocus/autofocus.directive';
export * from './autofocus/autofocus.module';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
